export default __webpack_public_path__ + "static/media/esportsBanner.1b4e3e0e.jpg";